import * as React from 'react'

import ModuleCard from './ModuleCard'
import IconType from '../../general/Icon/iconTypes'
import { colors } from '@lmc/common/constants'

export const GroupPlanModuleCard = () => (
  <ModuleCard
    backgroundColor={colors.purple}
    icon={IconType.GroupsHexagon}
    link="/"
    linkText="Find out more"
    subtitle="Monitor care delivery and performance across multiple sites."
    title="Group Plan"
    onClick={() =>
      window.open(
        'https://support.logmycare.co.uk/en/collections/2248853-the-group-plan'
      )
    }
  />
)
